'use client'

import { motion } from "framer-motion"
import { Instagram, Facebook, Mail } from "lucide-react"

const Tiktok = ({ className = "w-4 h-4", strokeWidth = 1.5 }: { className?: string; strokeWidth?: number }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
    >
        <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
)

const socials = [
    {
        icon: Instagram,
        href: "https://www.instagram.com/leqiustudiomelaka?igsh=MXFiOHVyam5udnppZw%3D%3D&utm_source=qr",
        label: "Instagram"
    },
    {
        icon: Facebook,
        href: "https://www.facebook.com/share/1DfPHD8Pg4/?mibextid=wwXIfr",
        label: "Facebook"
    },
    {
        icon: Tiktok,
        href: "https://www.tiktok.com/@studiorayamelaka_?_r=1&_t=ZS-940nEXxsQS0",
        label: "Tiktok"
    },
    {
        icon: Mail,
        href: "mailto:leqiucreative@gmail.com",
        label: "Email"
    },
]

export const SocialIcons = () => {
    return (
        <div className="flex gap-4">
            {socials.map((social, idx) => (
                <motion.a
                    key={idx}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileHover={{ y: -4, scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                    className="w-10 h-10 rounded-full border border-border/50 flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors bg-card/50"
                    aria-label={social.label}
                >
                    <social.icon className="w-4 h-4" strokeWidth={1.5} />
                </motion.a>
            ))}
        </div>
    )
}
